import React, {useCallback} from 'react';
import {useNavigate, useParams} from 'react-router-dom';

import {BasicPage} from 'src/components/basic-page';
import {ServerResponseHandler} from 'src/components/server-response-handler';
import {Skeleton} from 'src/components/skeleton';

import Button from '@pb/kit-component-button';
import {Group} from '@pb/kit-component-group';
import Loading from '@pb/kit-component-loading';
import {pluralize} from '@pb/kit-formatters';


import {NoContentView} from './content/no-content-view';
import {UserNotificationsContent} from './content/user-notifications-content';
import {useGetUsersNotifications} from './hooks/useGetUsersNotifications';
import {UserNotificationsSidebar} from './sidebar/user-notifications-sidebar';

export const UserNotifications = () => {
    const {notificationId} = useParams<{notificationId: string}>();
    const navigate = useNavigate();

    const {
        isLoading: isNotificationsLoading,
        loadingError: notificationsLoadingError,
        data: notifications,
    } = useGetUsersNotifications();

    const back = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    return (
        <Skeleton shown={isNotificationsLoading} view={<Loading fast={true}/>}>
            <ServerResponseHandler serverError={notificationsLoadingError}>
                <BasicPage
                    title="Notifications"
                    subtitle={pluralize(`${notifications.length} Notification[s]`, notifications.length)}
                    buttonsBlock={<Button variant="Type.TERTIARY" onClick={back}>Back</Button>}>
                    <Group gap="none" style={{flexGrow: 1}}>
                        <UserNotificationsSidebar notifications={notifications}/>
                        {notificationId
                            ? <UserNotificationsContent notificationId={notificationId}/>
                            : <NoContentView/>}
                    </Group>
                </BasicPage>
            </ServerResponseHandler>
        </Skeleton>
    );
};
